/**
 * Desktop search layer (Lavazza):
 * - Opens on first character typed in the header search field (sm+ viewport)
 * - Relocates AJAX suggestions into the full-width layer when query length > 1
 * - Most Popular categories from SearchServices-GetMostPopularCategories in editorial slot
 * - Header switches to logo + search + Close; page content is dimmed
 */
const DESKTOP_MIN_WIDTH = 1025;
const mostPopularCategories = require('./mostPopularCategories');

let $activeField = null;

function isDesktopViewport() {
	return $(window).width() >= DESKTOP_MIN_WIDTH;
}

function isDesktopSearchField($field) {
	return isDesktopViewport()
		&& !$field.closest('#header-search-mobile').length
		&& !!$field.closest('.main-header-bar .search').length;
}

function getLayer() {
	return $('.search-desktop-layer').first();
}

function getLayerDynamic() {
	return getLayer().find('.search-desktop-layer__dynamic');
}

function getLayerEditorial() {
	return getLayer().find('.search-desktop-layer__editorial');
}

function getOverlay() {
	return $('.search-desktop-overlay').first();
}

function isLayerOpen() {
	return $('html').hasClass('is-desktop-search-open');
}

function showEditorial() {
	return mostPopularCategories.loadIntoEditorial(getLayer(), getLayerEditorial())
		.then(function () {
			updateOverlayPosition();
		});
}

function hideEditorial() {
	mostPopularCategories.hideEditorial(getLayerEditorial());
}

function updateOverlayPosition() {
	const $layer = getLayer();
	const $overlay = getOverlay();

	if (!$layer.length || !$overlay.length || $layer.hasClass('d-none')) {
		return;
	}

	const layerEl = $layer[0];
	if (!layerEl) {
		return;
	}

	const layerBottom = layerEl.getBoundingClientRect().bottom;
	$overlay.css('top', `${layerBottom}px`);
}

function showOverlay() {
	const $overlay = getOverlay();
	if (!$overlay.length) {
		return;
	}

	$overlay.removeClass('d-none').attr('aria-hidden', 'false');
	updateOverlayPosition();
}

function hideOverlay() {
	const $overlay = getOverlay();
	if (!$overlay.length) {
		return;
	}

	$overlay.addClass('d-none').attr('aria-hidden', 'true');
}

function openDesktopSearchLayer($field) {
	if (!isDesktopSearchField($field)) {
		return;
	}

	$activeField = $field;

	$('html').addClass('is-desktop-search-open');
	$field.closest('.search-container').addClass('search-container--open');
	getLayer().removeClass('d-none').attr('aria-hidden', 'false');
	$field.attr('aria-expanded', 'true');
	getLayerDynamic().empty();
	showEditorial();
	showOverlay();
	$(window).trigger('scroll');

	if (window.lavazzaGtm && window.lavazzaGtm.search) {
		window.lavazzaGtm.search.trackLayerOpen();
	}
}

function stopSuggestionsSpinner($field) {
	if (isDesktopSearchField($field)) {
		getLayer().spinner().stop();
		return;
	}

	$.spinner().stop();
}

function startSuggestionsSpinner($field) {
	if (isDesktopSearchField($field)) {
		getLayer().spinner().start();
		return;
	}

	$.spinner().start();
}

function closeDesktopSearchLayer() {
	if (!isLayerOpen()) {
		return;
	}

	getLayer().spinner().stop();
	$('html').removeClass('is-desktop-search-open');
	$('.main-header-bar .search-container').removeClass('search-container--open');
	hideOverlay();
	getLayer().addClass('d-none').attr('aria-hidden', 'true');
	getLayerDynamic().empty();
	hideEditorial();

	if ($activeField && $activeField.length) {
		$activeField.val('').attr('aria-expanded', 'false');
	}

	$activeField = null;
	$(window).trigger('scroll');

	if (window.lavazzaGtm && window.lavazzaGtm.search) {
		window.lavazzaGtm.search.trackLayerClose();
	}
}

function moveSuggestionsToLayer($wrapper) {
	const $content = $wrapper.children();
	if (!$content.length) {
		return;
	}

	getLayerDynamic().empty().append($content);
	$wrapper.empty();
}

function handleDesktopInput($field) {
	const length = $field.val().length;

	if (length === 0) {
		getLayerDynamic().empty();
		showEditorial();
		return;
	}

	if (!isLayerOpen()) {
		openDesktopSearchLayer($field);
		return;
	}

	if (length === 1) {
		getLayerDynamic().empty();
		showEditorial();
	}
}

function handleSuggestionsResponse($field) {
	if (!isLayerOpen() || !isDesktopSearchField($field)) {
		return;
	}

	const queryLength = $field.val().length;
	const $wrapper = $field.siblings('.suggestions-wrapper');

	if (queryLength === 1) {
		$wrapper.empty();
		getLayerDynamic().empty();
		showEditorial();
		return;
	}

	if (queryLength > 1) {
		moveSuggestionsToLayer($wrapper);
		const $dynamic = getLayerDynamic();
		const hasResults = $dynamic.find('.suggestions').length > 0
			&& !$dynamic.find('.suggestions--empty').length;

		if (hasResults) {
			hideEditorial();
		} else {
			showEditorial();
		}
		updateOverlayPosition();
	}
}

function bindEvents() {
	$(document).on('focusin click', '.main-header-bar .search .search-field', function () {
		const $field = $(this);

		if (isDesktopSearchField($field) && !isLayerOpen()) {
			openDesktopSearchLayer($field);
		}
	});

	$(document).on('input', '.main-header-bar .search .search-field', function () {
		const $field = $(this);

		if (isDesktopSearchField($field)) {
			handleDesktopInput($field);
		}
	});

	$(document).on('click', '.search-desktop-close', function(e) {
		e.preventDefault();
		closeDesktopSearchLayer();
	});

	$(document).on('click', '.search-desktop-overlay', function(e) {
		if (!isLayerOpen()) {
			return;
		}

		e.preventDefault();
		closeDesktopSearchLayer();
	});

	$(document).on('keydown', function(e) {
		if (!isLayerOpen() || e.key !== 'Escape') {
			return;
		}

		e.preventDefault();
		closeDesktopSearchLayer();
	});

	$(window).on('resize scroll', function() {
		if (!isDesktopViewport()) {
			if (isLayerOpen()) {
				closeDesktopSearchLayer();
			}
			return;
		}

		if (isLayerOpen()) {
			updateOverlayPosition();
		}
	});
}

module.exports = function initDesktopSearch() {
	if (!getLayer().length) {
		return;
	}

	bindEvents();
};

module.exports.handleSuggestionsResponse = handleSuggestionsResponse;
module.exports.startSuggestionsSpinner = startSuggestionsSpinner;
module.exports.stopSuggestionsSpinner = stopSuggestionsSpinner;
